import { render, staticRenderFns } from "./ServicerDetails.vue?vue&type=template&id=0c1cd3da&"
import script from "./ServicerDetails.vue?vue&type=script&lang=ts&"
export * from "./ServicerDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports